// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3gGMe","label":"CategoryService_label__PyXJB","location":"CategoryService_location__2kngG"};